import { render } from "./turnover.vue?vue&type=template&id=1a055ebc&scoped=true"
import script from "./turnover.vue?vue&type=script&lang=js"
export * from "./turnover.vue?vue&type=script&lang=js"

import "./turnover.vue?vue&type=style&index=0&id=1a055ebc&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a055ebc"]])

export default __exports__